import PdfDocumentPreview from "./PdfDocumentPreview.jsx";

export default function PdfInvoicePreview({ invoiceId, isPreparing = false }) {
  return (
    <PdfDocumentPreview
      documentId={invoiceId}
      endpointBase="/invoices/pdf"
      isPreparing={isPreparing}
      emptyMessage="Generate an invoice preview to view the real PDF."
      preparingTitle="Preparing PDF preview"
      preparingText="Generating the invoice and loading the real PDF."
    />
  );
}
